module.exports = __webpack_public_path__ + "static/media/BAP1.4a2d13bf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP1.png
 ** module id = 675
 ** module chunks = 0
 **/